import React from 'react';
import HighlightTitle from './HighlightTitle';
import { Container, ValuesWrapper } from './Values.styles';

export interface ValuesProps {
  valueOne: JSX.Element;
  valueTwo: JSX.Element;
  valueThree: JSX.Element;
  backgroundColor?: string;
  fontColor?: string;
  className?: string;
}

/**
 *
 * @param props
 * All values will be passed to the Highlight Title component
 * i.e. Pass "<span> Quick and easy </span> for both you and your guests" and quick and easy will be the highlight
 * @returns
 */
const Values: React.FC<ValuesProps> = (props) => {
  const { valueOne, valueTwo, valueThree, backgroundColor, fontColor, className } = props;
  return (
    <Container className={className}>
      <ValuesWrapper backgroundColor={backgroundColor} fontColor={fontColor}>
        <HighlightTitle isH1={false}>{valueOne}</HighlightTitle>
        <hr />
        <HighlightTitle isH1={false}>{valueTwo}</HighlightTitle>
        <hr />
        <HighlightTitle isH1={false}>{valueThree}</HighlightTitle>
      </ValuesWrapper>
    </Container>
  );
};

export default Values;
